import { computed } from 'vue';
import { useStore } from 'vuex';
import ExternalCoupon from '@/models/entities/items/external-coupon';
import ItemSummary from '@/models/entities/items/item-summary';

const useCouponAvailability = () => {
  const store = useStore();

  const isCustomer = computed(() => store.getters['user/isCustomer']);
  const clippedCoupons = computed(() => store.getters['coupons/getClippedCoupons']);
  const redeemedCoupons = computed(() => store.getters['coupons/getRedeemedCoupons']);

  const couponDisplayable = (coupon: ExternalCoupon): boolean => {
    return coupon?.validForStore;
  };

  const canDisplayCoupon = (coupon: ExternalCoupon): boolean => {
    const isClipped = clippedCoupons.value?.includes(coupon.id) ?? false;
    const isRedeemed = redeemedCoupons.value?.includes(coupon.id) ?? false;

    if (isClipped || isRedeemed) {
      return true;
    }

    return couponDisplayable(coupon);
  };

  const displayableCoupons = (item: ItemSummary): Array<ExternalCoupon> => {
    if (item?.coupons) {
      if (isCustomer.value) {
        return item.coupons?.filter((coupon: ExternalCoupon) => canDisplayCoupon(coupon));
      }
      return item.coupons?.filter((coupon: ExternalCoupon) => couponDisplayable(coupon));
    }
    return [];
  };

  return {
    isCustomer,
    clippedCoupons,
    redeemedCoupons,
    displayableCoupons,
    canDisplayCoupon,
    couponDisplayable,
  };
};

export default useCouponAvailability;
